import { ChangeDetectorRef, Directive, Input, OnInit } from "@angular/core";
import moment from "moment";
import { IMetadataImage } from "../../../../interfaces/i-metadataimage";
import { IProjectAOI } from "../../../../interfaces/i-project-aoi";
import { ProjectService } from "../../../../services/internal-services/project.service";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { BaseTimelineComponent } from "../timeline/base-timeline.component";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Directive()
export abstract class BaseDiscreteSelectorComponent extends BaseTimelineComponent implements OnInit {
  private _selectedAOI: IProjectAOI;

  private _selectedImage: IMetadataImage;

  public timelineTooltip = "";

  enabledFilters = false;

  @Input()
  set selectedImage(image: IMetadataImage) {
    this.selectedAOI = ProjectService.imageProject(this._aois, image);
    this._selectedImage = image;
  }

  protected constructor(
    public googleAnalyticsService: GoogleAnalyticsService,
    public cdr: ChangeDetectorRef,
    public flagService: FeatureFlagsService,
  ) {
    super(googleAnalyticsService, cdr, flagService);
  }

  ngOnInit() {
    this.selectedImage = this.viewerService.getSelectedImage();
  }

  @Input()
  set aois(aois: IProjectAOI[]) {
    this.aoiPosition = [];
    this._aois = aois
      ?.filter((aoi) => aoi.hasNonArchivedOrientation(this.viewerService.orientationSelected))
      .sort((a1, a2) => this.getDate(a1)?.getTime() - this.getDate(a2)?.getTime());
    this.showSlider = !!this._aois?.length;
    this.showMiniSlider = this._aois?.length === 1;

    this.preCalculateFixedDates(this._aois);
    this.createSliderOptions();
    this.selectedAOI = ProjectService.imageProject(this._aois, this.selectedImage); //It is necessary to update the value of selectedAOI after creating the slider to select the value between maxValue and minValue
    // this.updateSliderValue();
  }

  get aois(): IProjectAOI[] {
    return this._aois;
  }

  onSliderAreaClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
  }

  updateSliderValue() {
    const newIndex = this._aois?.findIndex((item) => item.getName() === this.selectedAOI?.getName());
    this.sliderControl.reset(newIndex);
    this.cdr.detectChanges();
  }

  get selectedImage(): IMetadataImage {
    return this._selectedImage;
  }

  set selectedAOI(aoi: IProjectAOI) {
    this._selectedAOI = aoi;
    this.updateSliderValue();
  }

  get selectedAOI(): IProjectAOI {
    return this._selectedAOI;
  }

  getLegend(value: number): string {
    const aoi = this._aois ? this._aois[value] : null;
    let legend = "";
    if (aoi) {
      const date = aoi.getNewestImage(this.viewerService.orientationSelected)?.capture_date;
      if (this.showProjectDetails(value)) {
        if (aoi.isGraySky()) {
          legend = `<br><span class="legend-limits">${moment(date).format("MMM DD, YYYY")}</span>`;
        }
        legend = `<br><span class="legend-limits">${moment(date).format("MMM YYYY")}</span>`;
      } else if (this.showProjectYear(value)) {
        legend = `<span class="legend-year">'${moment(date).format("YY")}</span>`;
      }
    }
    if (this.enabledDebug) {
      legend += ` ${aoi.getLayerName()}-${aoi.getLayer()}`;
    }
    return legend;
  }

  showProjectYear(value: number): boolean {
    return (
      value === 0 || (value > 0 && this._aois[value].getMaxDate("YYYY") !== this._aois[value - 1].getMaxDate("YYYY"))
    );
  }

  getTickColor(value: number): string {
    super.getTickColor(value);
    return "rgba(255, 255, 255, 1)";
  }
}
